/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import { AppContext, ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';


let schemasByGroup = null;
let cacheKey = null;

const buildCache = (list) => {
    cacheKey = list;
    schemasByGroup = {};
    list.forEach((schema) => {
        const groupId = schema.groupId;
            //className = schema.className,
            //subType = schema.subType;

        schemasByGroup[groupId] = schema;
    });
};

export default class GroupSchemaStore extends ClassRemoteDataStore {

    constructor() {
        super(AppContext.getDispatcher(), ClassNames.GroupSchema);
    }

    getProps() {
        return this.getRemoteData('group-schemas').item;
    }

    getByGroupId(groupId) {
        if (cacheKey != this.getProps()) {
            buildCache(this.getProps());
        }
        return schemasByGroup[ groupId ];
    }

    reduce(state, action) {
        return super.reduce(state, action);
    }

}



// WEBPACK FOOTER //
// ./js/stores/GroupSchemaStore.js